import {BrowserModule} from '@angular/platform-browser';
import {ModuleWithProviders, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeModule} from './home/home.module';
import {
  ApiService,
  ArticlesResolver,
  ArticlesService,
  AuthService,
  HomeCarouselItemsResolver,
  JwtService,
  ReferencesResolver,
  SharedModule,
  StateService
} from './shared';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpConfigInterceptor} from './shared/service/http-config.interceptor';
import {ToastrModule} from 'ngx-toastr';
import {CrudUtilities} from './shared/util/crud-utilities';
import {AddressUtils} from './shared/util/address-utils';
import {EmbedVideo} from 'ngx-embed-video/dist';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {RouterModule} from '@angular/router';
import 'hammerjs';
import localeHu from '@angular/common/locales/hu';
import {registerLocaleData} from '@angular/common';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {CmsService} from './shared/service/cms.service';
import {AngularFireModule} from '@angular/fire';
import {environment} from '../environments/environment';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {NgxHmCarouselModule} from 'ngx-hm-carousel';
import {HomeCarouselService} from './shared/service/home-carousel.service';
import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {ReferencesService} from './shared/service/references.service';
import {PartnerService} from './shared/service/partner.service';
import {PartnerItemsResolver} from './shared/resolvers/partner-items-resolver.service';
import {AgmCoreModule} from '@agm/core';
import {ArticleResolver} from './shared/resolvers/article-resolver.service';
import {FlatManagerService} from './shared/service/flat-manager.service';
import {FlatsResolver} from './shared/resolvers/flats-resolver.service';
import {FlatResolver} from './shared/resolvers/flat-resolver.service';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {SuiModule} from 'ng2-semantic-ui';
import {MarketingItemManagerPageComponent} from './home/admin/components/marketing-item-manager-page/marketing-item-manager-page.component';
import {MarketingItemsResolverService} from './shared/resolvers/marketing-items-resolver.service';
import {RealEstateAgentItemsResolver} from './shared/resolvers/real-estate-agent-items-resolver.service';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig} from '@angular/material/dialog';
import {GalleryResolverService} from './shared/resolvers/gallery-resolver.service';
import {GalleriesService} from './shared/service/galleries.service';

registerLocaleData(localeHu, 'hu');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const defaultDialogConfig = new MatDialogConfig();
defaultDialogConfig.width = '600px';
defaultDialogConfig.hasBackdrop = true;
defaultDialogConfig.autoFocus = false;

export const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: 'https://httpbin.org/post',
  maxFilesize: 1,
  acceptedFiles: 'image/*',
  clickable: true,
  maxFiles: 1,
  uploadMultiple: false,
  autoReset: null,
  errorReset: null,
  cancelReset: null,
  autoProcessQueue: false,
  autoQueue: false,
};


const rootRouting: ModuleWithProviders = RouterModule.forRoot([], {useHash: true});


@NgModule({
  declarations: [
    AppComponent,
    MarketingItemManagerPageComponent
  ],
  imports: [
    rootRouting,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule,
    HomeModule,
    ToastrModule.forRoot({
      timeOut: 100000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    EmbedVideo.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    AngularSvgIconModule,
    CKEditorModule,
    NgxHmCarouselModule,
    DropzoneModule,
    LeafletModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDqEJoBGxf9lb38QXI9J3lcvnUpy-AVnVA',
      libraries: ['places']
    }),
    SuiModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true},
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: defaultDialogConfig},
    {provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG},
    ApiService,
    JwtService,
    StateService,
    AuthService,
    ArticlesService,
    ArticlesResolver,
    ArticleResolver,
    CrudUtilities,
    AddressUtils,
    CmsService,
    HomeCarouselService,
    HomeCarouselItemsResolver,
    ReferencesService,
    GalleriesService,
    ReferencesResolver,
    PartnerService,
    PartnerItemsResolver,
    RealEstateAgentItemsResolver,
    MarketingItemsResolverService,
    GalleryResolverService,
    FlatManagerService,
    FlatsResolver,
    FlatResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
